import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class CondAttribute extends Sensor {
  public condChart: any;
  private condSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.condChart = null;
    this.condSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }
      this.ensureArraySize(this.condSensor, position);
      this.condSensor[position].push([timestamp, element.cond]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredCond = this.condSensor.filter(series => series.length > 0);

    const positionNodeCond = this.condSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.condChart = this.getConfigChar(
      'cond',
      this.getChartSeriesNewNode('Sensor', filteredCond, positionNodeCond),
      this.getRanges('cond'),
      this.getLimits('cond')
    );
  }

  public hasCondSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.condSensor.length &&
      this.condSensor[index].length > 0
    );
  }

  public getCondSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.condSensor.length) {
      const sensorData = this.condSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Conductividad', value: 'cond' }
    ];
  }
}
